import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from "./shared/components/header/navbar/navbar.component";
// import { TopNavbarComponent } from "./shared/components/header/navbar/top-navbar.component";
import { BottomNavComponent } from './shared/components/footer/bottom-nav/bottom-nav.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NavbarComponent,
    // TopNavbarComponent,
    BottomNavComponent
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  title = "Family Health Advantage"
}
